
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ActiveDealsSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const ActiveDealsSearch = ({ searchTerm, onSearchChange }: ActiveDealsSearchProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Search properties..."
        className="pl-8 bg-muted"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};
